import { render, staticRenderFns } from "./payment-table.vue?vue&type=template&id=7201ffd0&scoped=true&"
import script from "./payment-table.ts?vue&type=script&lang=ts&"
export * from "./payment-table.ts?vue&type=script&lang=ts&"
import style0 from "./payment-table.scss?vue&type=style&index=0&id=7201ffd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7201ffd0",
  null
  
)

export default component.exports